import {Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

const AchievementItemSkeleton = () => (
  <Grid
    sx={{
      width: '197px',
      minWidth: '197px',
      borderRadius: '12px',
      backgroundColor: 'background.paper',
    }}>
    <Grid
      size={12}
      p={'12px'}
      display={'flex'}
      justifyContent={'space-between'}
      sx={{
        backgroundColor: 'background.default',
        borderRadius: '12px 12px 0px 0px',
      }}>
      <Grid display={'flex'} alignItems={'center'}>
        <Skeleton variant="circular" width="48px" height="48px" />
        <Grid ml={1}>
          <Skeleton
            variant="rectangular"
            width="60px"
            height={'0.8rem'}
            sx={{mb: 1}}
          />
          <Skeleton variant="rectangular" width="60px" height={'0.8rem'} />
        </Grid>
      </Grid>
    </Grid>
    <Grid
      size={12}
      px={2}
      pb={2}
      mt={2}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'space-between'}>
      <Grid display={'flex'} flexDirection={'column'}>
        <Skeleton
          variant="rectangular"
          width="60px"
          height={'0.8rem'}
          sx={{mb: 1}}
        />
        <Skeleton
          variant="rectangular"
          width="160px"
          height={'0.4rem'}
          sx={{mb: 1}}
        />
        <Skeleton variant="rectangular" width="110px" height={'0.4rem'} />
      </Grid>
    </Grid>
  </Grid>
);

export default AchievementItemSkeleton;
